export default __webpack_public_path__ + "static/media/cartilha.0c6f3e1e.pdf";